module.exports = __webpack_public_path__ + "img/expostyle_1511_bahamas_green_pantone155416tpg.b59953a6.jpg";